import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OnboardingUser, RequiredField, TenantField } from '../models/onboarding/on-boarding-user.model';
import { TenantConfigSearch } from '../models/onboarding/tenant-config-search.model';
import { TenantConfig } from '../models/onboarding/tenant-config.model';
/*import { UserFileNote } from '../models/onboarding/user-file-note.model';*/
import { AuthService } from '../services/auth.service';
import { ApiClientService } from './common/api-client.service';
import { State } from '../models/state.model';
import { DocumentType } from '../models/onboarding/document-type.model';
import { OnboardingUserSearch } from '../models/onboarding/on-boarding-user-search.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { UserFile } from '../models/onboarding/user-file.model';
import { UserFileSearch } from '../models/onboarding/user-file-search.model';
import { VerifyOnboardingUserRequest } from '../models/onboarding/verifyOnboardUserRequest.model';
import { ContactModel } from '../models/packages/contact.model';
import { BackgroundQuestionDetail } from '../models/background-question-detail.model';
import { UserNotes } from '../models/onboarding/user-notes.model';
import { UserFileStatus } from '../models/onboarding/user-file-status.model';
import { NonUnifomBGQuestion, NonUniformQuestionDetail } from '../models/NonUnifomBGQuestion.model';
import { SystemDefaultDocumentChecklist } from 'models/defaultDocumentChecklist.model';
import { UserInternalNoteInsertData, UserInternalNotes } from '../models/onboarding/user-internal-notes.model';
import { RequiredDocumentConfig } from '../models/onboarding/required-document-config.model';

export interface SidebarCount {
  userInternalNotesCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class OnBoardingService {

  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient) { }


  public configSubject = new BehaviorSubject<RequiredDocumentConfig | null>(null);

  configSub = this.configSubject.asObservable();

  setRequiredDocumentData(config: RequiredDocumentConfig): void {
    this.configSubject.next(config);
  }
  getTenantFileConfig(searchParams: TenantConfigSearch, showLoading = true): Observable<TenantConfig[]> {
    return this.apiClient.post(`api/onboarding/getTenantFileConfig`, searchParams, null, showLoading);
  }

  getOnboardedUsers(searchParams: OnboardingUserSearch): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/onboarding/getOnboardingUsers`, searchParams);
  }

  insertTenantFileConfig(tenantConfigs: TenantConfig[]): Observable<any> {
    const formData = new FormData();
    formData.append('tenantConfigsJson', JSON.stringify(tenantConfigs));

    tenantConfigs.forEach((config) => {
      if (config.file) {
        formData.append('files', config.file, config.file.name);
      }
    });

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/onboarding/insertTenantFileConfig`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  uploadUserFile(userFiles: UserFile[]): Observable<any> {
    if (!userFiles.every(config=> config.file instanceof Blob)) {
      throw new Error('One or more files are not valid.');
    }

    const formData = new FormData();
    formData.append('userFileJson', JSON.stringify(userFiles));

    userFiles.forEach((config) => {
      if (config.file) {
        if (config.file instanceof Blob) {
          formData.append('files', config.file, config.file.name);
        }
      }
    });

    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );

    return this.http.post(environment.baseUrl + `api/onboarding/uploadUserFiles`, formData, {
      headers: headers,
      reportProgress: true
    });
  }

  updateTenatFileConfig(tenantConfig: TenantConfig): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateTenatFileConfig`, tenantConfig);
  }

  updateOnboardingUserMemo(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserMemo`, user);
  }

  declineOnboardingUser(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/declineOnboardingUser`, user);
  }

    onboardingStatusUpdate(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/onboardingStatusUpdate`, user);
  }

  insertOnboardingUser(onboardingUsers: OnboardingUser): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/onboarding/insertOnboardingUser`, onboardingUsers);
  }

  inviteAgainAndSendEmail(onboardingUsers: OnboardingUser): Observable<OnboardingUser> {
    return this.apiClient.post(`api/onboarding/inviteAgainAndSendEmail`, onboardingUsers);
  }


  emailIsUsedOrNot(onboardingUsers: OnboardingUser): Observable<boolean> {
    return this.apiClient.post(`api/onboarding/emailIsUsed`, onboardingUsers);
  }

  insertOnboardingUserWithNpn(onboardingUser: OnboardingUser): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/onboarding/insertOnboardingUserWithNpn`, onboardingUser);
  }


   retrievePDB(requestObject: any) {
    return this.apiClient.post(`api/onboarding/retrievePDB`, requestObject, null, true);
  }

  insertUserNotes(userNotes: UserNotes): Observable<any> {
    return this.apiClient.post(`api/onboarding/InsertUserNotes`, userNotes, null, false);
  }

  getUserNotes(userId: number): Observable<UserNotes[]> {
    return this.apiClient.get(`api/onboarding/getUserNotes/${userId}`, null, null, false);
  }

  getStates(): Observable<State[]> {
    return this.apiClient.get(`api/onboarding/getStates`, null, null, false);
  }

    getSystemDefaultDocumentChecklist(): Observable<SystemDefaultDocumentChecklist[]> {
    return this.apiClient.get(`api/onboarding/getSystemDefaultDocumentChecklist`, null, null, false);
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    return this.apiClient.get(`api/onboarding/getDocumentTypes`,  null, null, false);
  }

  getUserFiles(userFileSearch: UserFileSearch, showLoading = true): Observable<UserFile[]> {
    return this.apiClient.post(`api/onboarding/getUserFiles`, userFileSearch, null, showLoading);
  }

  insertChecklist(userFileSearch: any, showLoading = true): Observable<number> {
    return this.apiClient.post(`api/onboarding/insertChecklistConfig`, userFileSearch, null, showLoading);
  }

  insertRequestedChecklist(userFileSearch: any, showLoading = true): Observable<number> {
    return this.apiClient.post(`api/onboarding/insertRequestedChecklist`, userFileSearch, null, showLoading);
  }

  sendVerificationCode(activateUrl: string) {
    var onboardingUser = {} as OnboardingUser;
    onboardingUser.activateUrl = activateUrl;
    return this.apiClient.post(`api/onboardingUser/sendVerificationCode`, onboardingUser, null, true);
  }

  verifyOnboardUser(verifyRequest: VerifyOnboardingUserRequest) {
    //return this.apiClient.post(`api/onboardingUser/verifyOnboardingUser`, verifyRequest, null, true);
    return this.apiClient.post(`api/OnboardingUser/verifyOnboardingUser`, verifyRequest, null, true);
  }

  setPwd(setPwdObj: any) {
    return this.apiClient.post(`api/OnboardingUser/setpassword`, setPwdObj, null, true);
  }


  downloadBulkImportTemplate() {
    return this.apiClient.exportGet(`api/onboarding/downloadBulkImportTemplate`, null, null, true);
  }

  uploadBulkImportFile(formData: FormData): Observable<any> {
    const header = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );
    return this.apiClient.uploadFile(`api/onboarding/uploadBulkImportFile`, formData, header);
  }

  public downloadOnboardingFile(formId: number, userId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/forms/downloadOnboardingFile/${formId}/${userId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  


  public downloadConfigFile(tenantFileConfigId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/forms/downloadTenantConfigFile/${tenantFileConfigId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }


  public downloadTenantCheckListFile(tenantFileConfigId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/forms/downloadTenantCheckListFile/${tenantFileConfigId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }
  public downloadUserFile(userFileId: number) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    var requestUrl = environment.baseUrl + `api/forms/downloadUserFile/${userFileId}`;

    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  deleteOnboardingUser(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/deleteOnboardingUser`, user);
  }

  archiveOnboardingUser(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/archiveOnboardingUser`, user);
  }


  archiveUserFile(userFileId: number, admin: boolean = true): Observable<any> {
    if (admin) {
      return this.apiClient.post(`api/onboarding/archiveUserFile/${userFileId}`, null);
    }
    else {
      return this.apiClient.post(`api/onboardingUser/archiveUserFile/${userFileId}`, null);
    }
  }


   archiveDocumentCheckList(userFileId: number, admin: boolean = true): Observable<any> {
      return this.apiClient.post(`api/onboarding/archiveUserDocumentChecklist/${userFileId}`, null);
  }

  unarchiveUserFile(userFileId: number, admin: boolean = true): Observable<any> {
    if (admin) {
      return this.apiClient.post(`api/onboarding/unarchiveUserFile/${userFileId}`, null);
    }
    else {
      return this.apiClient.post(`api/onboardingUser/unarchiveUserFile/${userFileId}`, null);
    }
  }

    unarchiveUserDocumentChecklist(userFileId: number, admin: boolean = true): Observable<any> {
      return this.apiClient.post(`api/onboarding/unarchiveUserDocumentChecklist/${userFileId}`, null);
  }
  deleteUserFile(userFileId: number): Observable<any> {
    return this.apiClient.post(`api/onboardingUser/deleteUserFile/${userFileId}`, null);
  }

   deleteUserCheckListFile(userFileId: number): Observable<any> {
    return this.apiClient.post(`api/onboardingUser/deleteUserCheckListFile/${userFileId}`, null, null, false);
  }

   updateUserCheckListFileStatus(userFileId: number , statusid:number): Observable<any> {
    return this.apiClient.post(`api/onboardingUser/updateUserCheckListFileStatus/${userFileId}/${statusid}`, null);
  }

  hireOnboardingUser(contact: ContactModel) {
    return this.apiClient.post(`api/onboarding/hireOnboardingUser`, contact, null, true);
  }
  updateWithOutNPNUser(contact: ContactModel) {
    return this.apiClient.post(`api/onboarding/updateWithOutNPNUser`, contact, null, true);
  }
  updateOnboardingUserFileStatus(userFile: UserFile) {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserFileStatus`, userFile, null, false);
  }

  updateUserSignature(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateUserSignature`, user);
  }

  downloadAll(userId: number , showArchived: boolean = false) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob' as 'json',
    };

    var requestUrl = environment.baseUrl + `api/forms/downloadAllUserFiles/${userId}`;
    if (showArchived != null) {
      requestUrl += `/${showArchived}`;
    }
    return this.http.get(requestUrl, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }

  updateUserEmail(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateUserEmail`, user);
  }

  insertUpdateUserBGQuestionDetails(backgroundQuestionDetails: BackgroundQuestionDetail[]): Observable<any> {
    return this.apiClient.post(`api/onboarding/insertUpdateUserBGQuestionDetails`, backgroundQuestionDetails, null, false);
  }

  getUserBGQuestionDetails(userId: number, showloading: boolean = true): Observable<BackgroundQuestionDetail[]> {
    return this.apiClient.get(`api/onboarding/getUserBGQuestionDetails/${userId}`, null, null, showloading);
  }

  getLatestBGQuestionUpdatedDate(userId: number): Observable<any> {
    return this.apiClient.get(`api/Onboarding/GetLatestBGQuestionUpdatedDate/${userId}`, null, null, false);
  }

  resndUserInvitation(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/resndUserInvitation`, user);
  }

  getUserProfileInfo(userId: number): Observable<ContactModel> {
    return this.apiClient.get(`api/contact/getUserProfileInfo/${userId}`);
  }

  updateOnboardingUserFileMemo(userFile: UserFile) {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserFileMemo`, userFile, null, true);
  }

  verifyOnboardingUserEmailExist(email: string) {
    var user = { email: email } as OnboardingUser;

    return this.apiClient.post(`api/onboarding/verifyOnboardingUserEmailExist`, user, null, true);
  }

  unarchiveOnboardingUser(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/unarchiveOnboardingUser`, user);
  }

  updateUserNotesTracking(userNotes: UserNotes , showLoading :boolean=true): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateUserNotesTracking`, userNotes ,null,showLoading);
  }

  getOnboardingUserChatCount(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/onboarding/getOnboardingUserChatCount/${userId}`, null, null, showLoading);
  }

  getisBackgroundQuestionsSubmit(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/onboarding/isBackgroundQuestionsSubmit/${userId}`,null, null, showLoading);
  }

  getisEmploymentHistorySubmit(userId: number, showLoading = true): Observable<OnboardingUser[]> {
    return this.apiClient.get(`api/onboarding/isEmploymentHistorySubmit/${userId}`,null, null, showLoading);
  }

  getUserFileStatuses(isOnboardedUser: boolean, showLoading = true): Observable<UserFileStatus[]> {
    if (isOnboardedUser) {
      return this.apiClient.get(`api/onboardingUser/getUserFileStatuses`,null, null, showLoading);
    }
    else {
      return this.apiClient.get(`api/onboarding/getUserFileStatuses`,null, null, showLoading);
    }
  }

  updateOnboardingUserMismatchName(user: OnboardingUser): Observable<any> {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserMismatchName`, user);
  }

   getActivitybyUserId(userId: number ,showLoading = true): Observable<any> {
    return this.apiClient.get(`api/onboarding/getActivitybyUserId/${userId}` , null,null, showLoading);
  }

  public getUserRegulatoryActionsByUserId(userId: number, sortDir: number, showLoading = true) {
    return this.apiClient.get(`api/onboarding/getUserRegulatoryActionListByUserId/${userId}/${sortDir}`, null, null, showLoading);
  }

  getOnboardingUserPDBDetails(userId: number): Observable<any>{
    return this.apiClient.get(`api/onboarding/getOnboardingUserPDBDetails/${userId}`, null, null, false);
  }

  updateOnboardingUserStates(onboardingUser: OnboardingUser): Observable<number> {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserStates`, onboardingUser);
  }

  fetchPdbDetails(onboardingUser: OnboardingUser): Observable<OnboardingUser[]> {
    return this.apiClient.post(`api/onboarding/fetchPdbDetails`, onboardingUser);
  }

  updateOnboardingUserStatesAndFiles(onboardingUser: OnboardingUser): Observable<number> {
    return this.apiClient.post(`api/onboarding/updateOnboardingUserStatesAndFiles`, onboardingUser);
  }
  GetUserNonUniformBGQuestionDetails(userId: number, showLoading: boolean = true): Observable<NonUniformQuestionDetail[]> {
    return this.apiClient.get(`api/onboarding/GetUserNonUniformBGQuestionDetails/${userId}`, null, null, showLoading);
  }
  insertUpdateUserNonUniformBGQuestionDetails(questions: NonUnifomBGQuestion[]) {
    return this.apiClient.post(`api/onboarding/InsertUpdateUserNonUniformBGQuestionDetails`, questions, null, false);
  }

  getUserInternalNotes(userId: number): Observable<UserInternalNotes[]> {
    return this.apiClient.get(`api/onboarding/getUserInternalNotes/${userId}`, null, null, false);
  }

  insertUserInternalNote(payload: UserInternalNoteInsertData): Observable<number> {
    return this.apiClient.post(`api/onboarding/insertUserInternalNote`, payload, null, false);
  }

  private userInternalNotesCounts = new BehaviorSubject<Record<number, SidebarCount>>({});
  userInternalNotesCounts$ = this.userInternalNotesCounts.asObservable();

  setUserInternalNotesCount(onboardingUsersId: number, count: number) {
    const current = this.userInternalNotesCounts.getValue();
    this.userInternalNotesCounts.next({
      ...current,
      [onboardingUsersId]: {
        userInternalNotesCount: count
      }
    });
  }

  getRequiredField(isProducer: boolean): Observable<RequiredField[]> {
    return this.apiClient.get(`api/onboarding/getRequiredField/${isProducer}`, null, null, false);
  }
  getTenantRequiredField(tenantId: number): Observable<TenantField[]> {
    return this.apiClient.get(`api/onboarding/getTenantRequiredField/${tenantId}`, null, null, false);
  }
  insertUpdateTenantRequiredField(payload: TenantField): Observable<number>{
    return this.apiClient.post(`api/onboarding/insertUpdateTenantRequiredField`, payload, null, false);
  }

  insertChecklistNew(
  userFileSearch: any,
  showLoading = true
): Observable<any> {
  const headers = new HttpHeaders().append(
    "Content-Disposition",
    "multipart/form-data"
  );

  return this.http.post(environment.baseUrl + `api/onboarding/insertChecklistConfigNew`, userFileSearch, {
    headers: headers
  });
}

public downloadCheckListTemplateFile(tenantFileConfigId: number) {

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/octet-stream',
    })
  };

  var requestUrl = environment.baseUrl + `api/onboarding/downloadCheckListTemplateFile/${tenantFileConfigId}`;

  return this.http.get(requestUrl, httpOptions)
    .pipe(map((response: any) => {
      let data = response;
      return data;
    }
    ));
}
  getTenantRequiredFlags(userId: number,tenantId: number): Observable<TenantField[]> {
    return this.apiClient.get(`api/onboarding/getTenantRequiredFieldFlags/${userId}/${tenantId}`, null, null, false);
  }
}
